
document.body.addEventListener('click', (e) => {
  const switcherButton = e.target.closest('.mobile-layout-switcher-btn');

  if (switcherButton) {
    const productGrid = document.querySelector('#product-grid');

    if (switcherButton.dataset.value === '1') {
      productGrid.classList.add('one-per-row');
    } else {
      productGrid.classList.remove('one-per-row');
    }
  }

  if (e.target.closest('.mobile-facets__open')) {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }
});


let updateCombinedHeaderHeightTimeout;
function updateCombinedHeaderHeight() {
  clearTimeout(updateCombinedHeaderHeightTimeout);
  updateCombinedHeaderHeightTimeout = setTimeout(() => {
    const header = document.querySelector('.header-wrapper');
    const announcementBar = document.querySelector('.utility-bar');
    let totalHeight = 0;

    if (header) {
      totalHeight += header.offsetHeight;
    }

    if (announcementBar) {
      totalHeight += announcementBar.offsetHeight;
    }

    document.documentElement.style.setProperty('--combined-header-height', `${totalHeight}px`);
  }, 500)
}

document.addEventListener('DOMContentLoaded', updateCombinedHeaderHeight);
window.addEventListener('resize', updateCombinedHeaderHeight);
window.addEventListener('orientationchange', updateCombinedHeaderHeight);
window.addEventListener('scroll', updateCombinedHeaderHeight);
